import { Component, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatSlideToggle } from '@angular/material';
import { ReminderFormGroup } from '../clinic-setup-form.model';
import { ClinicSetupService } from '../clinic-setup.service';
import { ClinicService } from './../../../core/api/clinic.service';
import { reminders, reminderSelectionKeys } from './reminder.model';

type RadioConfig = {
  name: string;
  formControlName: AbstractControl;
};
type RadioButton = {
  [key in string]: {
    key: string;
    deepCopyList?: any[];
  };
};

export type Radio = {
  radioConfig: RadioConfig;
  radioButtons: RadioButton;
};
@Component({
  selector: 'csi-questionnaire-reminder',
  templateUrl: './questionnaire-reminder.component.html',
  styleUrls: ['./questionnaire-reminder.component.css']
})
export class QuestionnaireReminderComponent implements OnInit {
  public reminderFormGroup: ReminderFormGroup = this.clinicSetupService.clinicSetupFormGroup
    .controls.reminderConfig;

  public reminderSelection = reminderSelectionKeys;
  public expirationQuestionnaireDate = null;

  constructor(public clinicSetupService: ClinicSetupService, public clinicService: ClinicService) {
    this.expirationQuestionnaireDate = this.clinicSetupService.clinicSetupFormGroup.value.questionnaireExpiry;
  }


  ngOnInit() {

    (reminderSelectionKeys || []).forEach((item, index) => {
      this.reminderFormGroup.addReminderControl(
       item.id +'',
        this.reminderFormGroup.controls.numberOfReminder
      );
    });

    this.clinicSetupService.clinicSetupFormGroup.controls.questionnaireExpiry.valueChanges.subscribe(
      expiry => {
        reminderSelectionKeys.forEach((item, index) => {
          const reminder = reminders.find(
            reminder => reminder.key === this.reminderFormGroup.controls[1 + ''].value
          );
          if (reminder && expiry <= reminder.numberOfDays) {
            this.reminderFormGroup.controls[index + 1 + ''].setValue(null);
          }
        });
      }
    );
  }
}
